// NewEmail.jsx

import React, { useState, useRef, useContext, useEffect } from "react";
import { UrlContext } from "../../contexts/UrlContext";
import AddNewEmail from "../../components/ProjectDetails/addNewEmail";
import DragAndDrop from "../../components/SharedProfiles/drag&drop";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Quill from 'quill';
import { AnimatePresence, motion } from "framer-motion";

const NewEmail = ({ onClose, onSend, defaultTo = [], defaultCc = [], defaultBcc = [], defaultSubject = "", defaultBody = "", quotedEmail = null }) => {
  const [subject, setSubject] = useState(defaultSubject);
  const [body, setBody] = useState(defaultBody);
  const [toRecipients, setToRecipients] = useState(defaultTo);
  const [from, setFrom] = useState([]);
  const [bcc, setBcc] = useState(defaultBcc);
  const [cc, setCc] = useState(defaultCc);
  const [includeSignature, setIncludeSignature] = useState(true);
  const [attachments, setAttachments] = useState([]);
  const [hasAttachment, setHasAttachment] = useState(false);
  const [openDragDrop, setOpenDragDrop] = useState(false);
  const [showBcc, setShowBcc] = useState(false);
  const [signatureHtml, setSignatureHtml] = useState("");
  const bodyRef = useRef(null);
  const signatureRef = useRef(null);
  const { API_URL } = useContext(UrlContext);

  useEffect(() => {
    adjustSignature();
  }, [signatureHtml, includeSignature]);

  const adjustSignature = () => {
    if (signatureRef.current) {
      const imgs = signatureRef.current.querySelectorAll("img");
      const lastThreeImgs = Array.from(imgs).slice(-3);
      lastThreeImgs.forEach((img, index) => {
        img.style.width = "auto";
        img.style.height = "auto";
        img.style.maxWidth = index !== 1 ? "100%" : "95px";
        img.style.maxHeight = index !== 1 ? "1000px" : "150px";
        if (index === 1) img.style.marginLeft = "2px";
      });
    }
  };

  const handleSend = () => {
    const fullBody = includeSignature ? `${body}<br>${signatureHtml}` : body;
    onSend({
      to: toRecipients,
      from,
      bcc_email: bcc,
      cc_email: cc,
      subject,
      body: fullBody,
      enableSignature: includeSignature,
      attachment: attachments,
    });
  };

  const removeAttachment = (index) => {
    const updated = [...attachments];
    updated.splice(index, 1);
    setAttachments(updated);
    if (updated.length === 0) setHasAttachment(false);
  };

  const fetchSignature = async () => {
    const tokenObj = localStorage.getItem("eph-token");
    if (!tokenObj) return;

    const token = JSON.parse(tokenObj).value;
    try {
      const res = await fetch(`${API_URL}account-settings`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      });
      const data = await res.json();
      const signature = data.signature
        .replace("{{name}}", `${data.user.sigtitle} ${data.user.sigfirstname} ${data.user.siglastname}`)
        .replace("{{designation}}", data.user.config)
        .replace("{{contactNumber}}", data.user.path_z);

      setSignatureHtml(signature);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchSignature();
  }, []);

  useEffect(() => {
    if (quotedEmail) {
      const quoted = generateQuotedHtml(quotedEmail);
      setBody((prev) => `${prev}<br>${quoted}`);
    }
  }, [quotedEmail]);
  

  const Font = Quill.import("formats/font");
  Font.whitelist = [
    "arial",
    "georgia",
    "times-new-roman",
    "courier-new",
    "verdana",
    "tahoma",
    "lucida",
  ];
  Quill.register(Font, true);

  const generateQuotedHtml = (original) => {
    const sender = original.from?.emailAddress?.name || original.from?.emailAddress?.address;
    const date = new Date(original.receivedDateTime).toLocaleString();
    const subjectLine = original.subject || "";
    const content = original.body?.content || "";

    return `
      <br><br><br>
      <div style="border-left: 2px solid gray; border-top: 1px solid lightgray; padding-left: 10px; margin-top: 20px; padding-top: 10px;">
        <p style="color: gray; font-size: 13px; margin-bottom: 8px;">
          On ${date}, ${sender} wrote:
        </p>
        ${content}
      </div>
    `;
  };

  return (
    <motion.div
      key="newEmail"
      initial={{ opacity: 0, y: 0 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 0 }}
      transition={{ duration: 0.25 }}
      className="decline-wrapper"
    >
      <div className="flex-container-decline-profile" style={{ width: "98%", height: "73%", padding: "0px", border: "none", overflowY: "hidden" }}>
        <div className="flex-item-decline-profile-header" style={{ flex: "2%", background: "#365561" }}>
          <div style={{ display: "flex", flexDirection: "row" }}><p style={{marginLeft: "5px", color: "white", fontWeight: "500"}}>Compose new email</p></div>
          <i className="fa-solid fa-xmark" style={{ marginRight: "5px", marginTop: "3px", color: "gray", cursor: "pointer" }} onClick={onClose} />
        </div>

        <div className="flex-item-sugest-time-slot-email" style={{ flex: "98%" }}>
          <div className="flex-container-emil" style={{ display: "flex", flexDirection: "column", marginTop: "10px" }}>
            <div className="flex-item-email-action" style={{ flex: "20%", borderBottom: "1px solid lightgrey" }}>
              <div className="flex-container-email-action-container" style={{ display: "flex", flexDirection: "row", marginBottom: "10px", gap: "10px", padding: "5px" }}>
                <div className="flex-item-email-action-container-item-send" style={{ flex: "5%", borderRadius: "5px", display: "flex", flexDirection: "column" }}>
                  <div onClick={handleSend} style={{ border: "1px solid lightgrey", borderRadius: "5px", height: showBcc ? "128px" : "82px", textAlign: "center", display: "flex", flexDirection: "column", cursor: "pointer", justifyContent: "center", alignItems: "center" }}>
                    <i className="fa-solid fa-paper-plane" style={{ marginTop: "15%", fontSize: "30px", color: toRecipients ? "#365561" : "gray" }}></i>
                    <span style={{ marginBottom: "10%" }}>Send</span>
                  </div>
                  <div style={{ textAlign: "center", cursor: "default" }}>
                    <i className="fa-solid fa-paperclip fa-xl" style={{ marginTop: "27px", cursor: "pointer", color: hasAttachment ? "#365561" : "grey" }} onClick={() => setOpenDragDrop(true)}></i>
                  </div>
                </div>

                <div className="flex-item-email-action-container-item-attendees" style={{ flex: "5%", display: "flex", flexDirection: "column", marginBottom: "10px", gap: "10px" }}>
                  <div style={{ border: "1px solid lightgrey", borderRadius: "5px", textAlign: "center" }}>
                    <p style={{ margin: "5px", fontSize: "16px" }}>To</p>
                  </div>
                  <div onClick={() => setShowBcc(true)} style={{ border: "1px solid lightgrey", borderRadius: "5px", textAlign: "center", cursor: "pointer" }}>
                    <p style={{ margin: "5px" }}>Cc</p>
                  </div>
                  {showBcc && (
                    <div onClick={() => setShowBcc(false)} style={{ border: "1px solid lightgrey", borderRadius: "5px", textAlign: "center", cursor: "pointer" }}>
                      <p style={{ margin: "5px" }}>Bcc</p>
                    </div>
                  )}
                  <div style={{ textAlign: "center" }}>
                    <p style={{ margin: "5px" }}>Subject</p>
                  </div>
                </div>

                <div className="flex-item-email-action-container-item-inputs" style={{ flex: "90%", display: "flex", flexDirection: "column", marginBottom: "10px", gap: "10px" }}>
                  <div className="input-attendees-subject" style={{ outline: "none", height: "36px" }}>
                    <AddNewEmail handleInputChange={setToRecipients} currentEmails={toRecipients} />
                  </div>
                  <div className="input-attendees-subject" style={{ outline: "none", height: "36px" }}>
                    <AddNewEmail handleInputChange={setCc} currentEmails={cc} />
                  </div>
                  {showBcc && (
                    <div className="input-attendees-subject" style={{ outline: "none", height: "36px" }}>
                      <AddNewEmail handleInputChange={setBcc} currentEmails={bcc} />
                    </div>
                  )}
                  <input className="input-attendees-subject" value={subject} onChange={(e) => setSubject(e.target.value)} style={{ outline: "none", height: "35px" }} />

                  {attachments.length > 0 && (
                    <div className="flex flex-wrap gap-3 mt-2">
                      {attachments.map((att, idx) => {
                        const blobUrl = URL.createObjectURL(
                          new Blob([Uint8Array.from(atob(att.base64), c => c.charCodeAt(0))], { type: att.contentType })
                        );
                        const fileType = att.contentType;
                        let icon = "fa-file";

                        if (fileType.includes("image")) icon = "fa-file-image";
                        else if (fileType.includes("pdf")) icon = "fa-file-pdf";
                        else if (fileType.includes("word")) icon = "fa-file-word";
                        else if (fileType.includes("excel")) icon = "fa-file-excel";
                        else if (fileType.includes("zip")) icon = "fa-file-zipper";
                        else if (fileType.includes("presentation") || fileType.includes("ppt")) icon = "fa-file-powerpoint";

                        return (
                          <div key={idx} className="flex items-center gap-2 border px-3 py-2 rounded-md bg-gray-100">
                            {att.contentType.startsWith("image/") ? (
                              <img src={blobUrl} alt={att.name} className="w-10 h-10 object-cover rounded" />
                            ) : (
                              <div className="w-10 h-10 flex items-center justify-center bg-gray-300 rounded text-gray-600">
                                <i className={`fa-solid ${icon}`} />
                              </div>
                            )}
                            <div className="flex-1 min-w-0">
                              <div className="text-sm font-medium text-gray-800 truncate">{att.name}</div>
                              <div className="text-xs text-gray-500">{Math.round(att.size / 1024)} KB • {att.contentType.split("/")[1]}</div>
                            </div>
                            <button onClick={() => removeAttachment(idx)} className="text-red-500 hover:text-red-700">
                              <i className="fa-solid fa-xmark"></i>
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="flex-item-email-body" style={{ flex: "80%" }}>
              <div>
                <ReactQuill
                  theme="snow"
                  value={body}
                  onChange={setBody}
                  modules={{
                    toolbar: [
                      [{ font: Font.whitelist }],
                      [{ header: [1, 2, false] }],
                      ["bold", "italic", "underline", "strike"],
                      [{ list: "ordered" }, { list: "bullet" }],
                      ["link"],
                    ],
                  }}
                  formats={["font", "header", "bold", "italic", "underline", "strike", "list", "bullet", "link"]}
                  style={{ overflowY: "auto", display: "flex", flexDirection: "column" }}
                />
                <style>
                  {`
                    .ql-editor {
                      min-height: 100px;
                      padding: 5px !important;
                      font-size: 14px !important;
                      font-family: Verdana, sans-serif;
                    }
                    .ql-container {
                      height: auto !important;
                      min-height: 100px;
                      padding-bottom: 10px;
                    }
                    .ql-container .ql-snow .ql-hidden {
                      display: none !important;
                    }
                    .ql-toolbar.ql-snow {
                      position: inherit;
                      top: 0;
                      right: 24px;
                      padding: 3px;
                      display: flex;
                      flex-wrap: nowrap;
                      gap: 10px;
                    }
                    .ql-font-arial { font-family: Arial, sans-serif; }
                    .ql-font-georgia { font-family: Georgia, serif; }
                    .ql-font-times-new-roman { font-family: "Times New Roman", serif; }
                    .ql-font-courier-new { font-family: "Courier New", monospace; }
                    .ql-font-verdana { font-family: Verdana, sans-serif; }
                    .ql-font-tahoma { font-family: Tahoma, sans-serif; }
                    .ql-font-lucida { font-family: "Lucida Sans Unicode", sans-serif; }
                    .ql-font-roboto { font-family: "Roboto", sans-serif; }
                    .ql-font-lato { font-family: "Lato", sans-serif; }

                    /* Dropdown font preview fix */
                    .ql-snow .ql-picker.ql-font .ql-picker-label::before,
                    .ql-snow .ql-picker.ql-font .ql-picker-item::before {
                      content: attr(data-value);
                      font-family: inherit;
                    }

                    .ql-picker-item[data-value="arial"]::before,
                    .ql-picker-label[data-value="arial"]::before {
                      font-family: Arial, sans-serif;
                      content: "Arial";
                    }

                    .ql-picker-item[data-value="georgia"]::before,
                    .ql-picker-label[data-value="georgia"]::before {
                      font-family: Georgia, serif;
                      content: "Georgia";
                    }

                    .ql-picker-item[data-value="times-new-roman"]::before,
                    .ql-picker-label[data-value="times-new-roman"]::before {
                      font-family: "Times New Roman", serif;
                      content: "Times New Roman";
                    }

                    .ql-picker-item[data-value="courier-new"]::before,
                    .ql-picker-label[data-value="courier-new"]::before {
                      font-family: "Courier New", monospace;
                      content: "Courier New";
                    }

                    .ql-picker-item[data-value="verdana"]::before,
                    .ql-picker-label[data-value="verdana"]::before {
                      font-family: Verdana, sans-serif;
                      content: "Verdana";
                    }

                    .ql-picker-item[data-value="tahoma"]::before,
                    .ql-picker-label[data-value="tahoma"]::before {
                      font-family: Tahoma, sans-serif;
                      content: "Tahoma";
                    }

                    .ql-picker-item[data-value="lucida"]::before,
                    .ql-picker-label[data-value="lucida"]::before {
                      font-family: "Lucida Sans Unicode", sans-serif;
                      content: "Lucida";
                    }
                  `}
                </style>

                <div>
                  <div className="custom-control custom-control-right custom-switch" style={{marginTop: "20px"}}>
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id="customSwitch1-emailComposer"
                      checked={includeSignature}
                      onChange={(e) => {
                        setIncludeSignature(e.target.checked);
                        adjustSignature()
                      }}
                    />
                    <label
                      className="custom-control-label"
                      for="customSwitch1-emailComposer"
                    >
                      <p style={{fontSize: "14px", color: "grey"}}>Include Signature?</p>
                    </label>
                  </div>
                  {includeSignature && (
                    <div ref={signatureRef} dangerouslySetInnerHTML={{ __html: signatureHtml }} />
                  )}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      
      <AnimatePresence>
        {openDragDrop && (
          <DragAndDrop
            key="dragDrop"
            setOpenDragDrop={setOpenDragDrop}
            setBase64Strings={setAttachments}
            setHasAttachment={setHasAttachment}
          />
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default NewEmail;